import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import IconArrow from '../atoms/assets/icons/IconArrow';
import { avatarData } from '../data/avatarData';
import {
  participantAge,
  participantLocation,
  participantOccupation
} from '../data/participantDetails';

const Schema = Yup.object().shape( {
  participantage: Yup.string(),
  participantoccupation: Yup.string(),
  participantlocation: Yup.string(),
  workshop: Yup.boolean(),
} );

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
`;

class DetailsForm extends Component {

  state = {
    redirect: false,
  };

  submitForm = ( values ) => {
    this.props.dispatch( {
      type: 'SET_PARTICIPANT',
      participantage: values.participantage,
      participantoccupation: values.participantoccupation,
      participantlocation: values.participantlocation,
      workshop: values.workshop,
    } );
    this.props.dispatch( {
      type: 'SET_AVATAR',
      currentAvatar: avatarData[0].prefix,
    } );
  };

  render() {
    if ( this.state.redirect ) {
      const firstAvatar = avatarData[0];
      return <Redirect push to={`/${firstAvatar.name}-${firstAvatar.options[0].id}`}/>;
    } else {
      return (
        <Formik
          initialValues={{
            participantage: participantAge[0].value,
            participantoccupation: participantOccupation[0].value,
            participantlocation: participantLocation[0].value,
            workshop: false,
          }}
          validationSchema={Schema}
          onSubmit={( values, { setSubmitting } ) => {
            this.submitForm( values );
            setSubmitting( false );
            this.setState( {
              redirect: true,
            } )
          }}>
          {( { isSubmitting } ) => (
            <Form>
              <p className="input-holder">
                <label>Age</label>
                <Field component="select" name="participantage">
                  {participantAge.map(ageRange => <option key={ageRange.value} value={ageRange.value}>{ageRange.text}</option>)}
                </Field>
                <ErrorMessage name="participantage" component="div"/>
              </p>

              <p className="input-holder">
                <label>Occupation</label>
                <Field component="select" name="participantoccupation">
                  {participantOccupation.map(occupation => <option key={occupation.value} value={occupation.value}>{occupation.text}</option>)}
                </Field>
                <ErrorMessage name="participantoccupation" component="div"/>
              </p>

              <p className="input-holder">
                <label>Location</label>
                <Field component="select" name="participantlocation">
                  {participantLocation.map(location => <option key={location.value} value={location.value}>{location.text}</option>)}
                </Field>
                <ErrorMessage name="participantlocation" component="div"/>
              </p>

              <label className="checkboxHolder">I am in a workshop
                <Field type="checkbox" name="workshop" />
                <span className="checkmark"/>
              </label>

              <p>Your input will help build the project. The avatar you create will be shared on the gallery.
              </p>

              <ButtonHolder>
              <button className="primary text button-icon" type="submit" disabled={isSubmitting}>Next<IconArrow /></button>
              </ButtonHolder>
            </Form>
          )}
        </Formik>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    participant: state.participant,
  };
}

export default connect( mapStateToProps )( DetailsForm );
